import { render } from "./ChangeSharedFSServiceOffering.vue?vue&type=template&id=bf6b369a&scoped=true"
import script from "./ChangeSharedFSServiceOffering.vue?vue&type=script&lang=js"
export * from "./ChangeSharedFSServiceOffering.vue?vue&type=script&lang=js"

import "./ChangeSharedFSServiceOffering.vue?vue&type=style&index=0&id=bf6b369a&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf6b369a"]])

export default __exports__